import { useState, useMemo } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { Formik } from 'formik';
import { GiftsReceivedLayout, PurchaseSummary } from 'components';
import { TableList } from 'components/gifts-table/TableList';
import { withLayout } from 'hocs';
import { columns } from './columns';
import { getConfig } from './config';
import { articles } from './mocks';
import './styles.scss';

function ArticlesToPay() {
  const [listOfArticles] = useState(articles);

  const { initialValues, schema } = useMemo(
    () => getConfig(listOfArticles),
    [listOfArticles]
  );

  return (
    <GiftsReceivedLayout
      title="Mis regalos para: "
      showAccumulatedAmount={false}
      className="ArticlesToPay"
    >
      <Row>
        <Col md={8}>
          <Formik initialValues={initialValues} validationSchema={schema}>
            {() => (
              <TableList
                className="mt-4 mb-5"
                data={listOfArticles}
                columns={columns}
              />
            )}
          </Formik>
        </Col>
        <Col md={4}>
          <PurchaseSummary
            className="mt-4 mb-5"
            articles={listOfArticles.map((currentArticle) => ({
              ...currentArticle,
              ...currentArticle.article,
            }))}
          >
            <Row className="mt-1">
              <Col xs={12} className="d-flex justify-content-center my-2">
                <Button variant="primary" className="PurchaseSummaryButtons">
                  Comenzar la compra
                </Button>
              </Col>
              <Col xs={12} className="d-flex justify-content-center my-2">
                <Button variant="secondary" className="PurchaseSummaryButtons">
                  Regresar al evento
                </Button>
              </Col>
            </Row>
          </PurchaseSummary>
        </Col>
      </Row>
    </GiftsReceivedLayout>
  );
}

export default withLayout(ArticlesToPay);
